import { render, staticRenderFns } from "./fcMovieDetail.vue?vue&type=template&id=28b64576"
import script from "./fcMovieDetail.vue?vue&type=script&lang=js"
export * from "./fcMovieDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports